module.exports = __webpack_public_path__ + "img/Character_Kaedehara_Kazuha_Thumb.4878363e.png";